import axios from 'axios';
import forge from 'node-forge';
import poptoken_builder from '../popToken/poptoken-builder-node';

export const axiosAzure = async ({
  method = 'get',
  url,
  data,
  otherHeaders = null,
}) => {
  if (!url || typeof url !== 'string') {
    throw new Error('Invalid URL: URL must be a non-empty string');
  }

  // === Step 1: Validate URL to avoid SSRF attacks ===
  const isValidUrl = validateUrl(url);
  if (!isValidUrl) {
    throw new Error('Invalid URL: SSRF protection - URL not allowed');
  }

  // === Step 2: Generate RSA Key Pair ===
  const keypair = forge.pki.rsa.generateKeyPair({ bits: 2048, e: 0x10001 });
  const publicKey = forge.pki.publicKeyToPem(keypair.publicKey);
  const privateKey = forge.pki.privateKeyToPem(keypair.privateKey);

  // === Step 4: Call GUEST_TOKEN_URL to get a fresh id_token ===
  const guestTokenHeader = {
    'Content-Type': 'application/json',
    'X-Authorization': createPopToken('post', url, '', data, privateKey),
  };

  const guestTokenBody = {
    client_id: import.meta.env.VITE_CLIENTID,
    cnf: publicKey,
  };

  const guestTokenResponse = await axios({
    method: 'post',
    url: import.meta.env.VITE_GUEST_TOKEN_URL,
    data: guestTokenBody,
    headers: guestTokenHeader,
  });

  const { id_token, access_token } = guestTokenResponse?.data;
  if (!id_token) {
    throw new Error('Failed to fetch fresh id_token from guestToken endpoint');
  }

  // === Step 5: Check if this endpoint should exclude mmfa-token ===
  const excludeMmfaToken = [
    import.meta.env.VITE_GUEST_TOKEN_URL,
    `${import.meta.env.VITE_API_BASE_URL_MEG}/session/create`,
  ];

  const shouldExcludeMmfaToken = excludeMmfaToken.some((apiUrl) =>
    url.startsWith(apiUrl)
  );

  const sessionToken = sessionStorage.getItem('sessionToken');

  const headers = {
    ...otherHeaders,
    Authorization: `Bearer ${id_token}`,
    'X-Auth-Originator': id_token,
    'X-Authorization': createPopToken(method, url, '', data, privateKey),
    ...(shouldExcludeMmfaToken
      ? {}
      : { 'mmfa-token': sessionToken }),
  };

  // === Step 7: Make the actual API call ===
  return axios({
    method,
    url,
    data,
    headers,
  });
};

export const createPopToken = (method, url, authorization, body, privateKey) => {
  const ehtsKeyValueMap = new Map();
  const pathname = new URL(url).pathname;
  // ehtsKeyValueMap.set('Authorization', authorization);
  // ehtsKeyValueMap.set('uri', pathname);
  ehtsKeyValueMap.set('http-method', method.toUpperCase());
  // if (!(method === 'get' || JSON.stringify(body) === '{}')) {
  //   ehtsKeyValueMap.set('body', method === 'get' ? '' : JSON.stringify(body));
  // }

  const privateKeyPemStr = '' + privateKey;
  try {
    const popToken = poptoken_builder.buildPopToken(
      ehtsKeyValueMap,
      privateKeyPemStr
    );
    return popToken;
  } catch (error) {
    console.log('Error:', error);
  }
};

// Helper function to validate URLs
const validateUrl = (url) => {
  try {
    const parsedUrl = new URL(url);
    // Ensure the URL is using HTTP or HTTPS protocols
    if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') {
      console.error('Invalid protocol:', parsedUrl.protocol);
      return false;
    }

    // Disallow URLs pointing to internal IP ranges
    const hostname = parsedUrl.hostname;
    if (isInternalIp(hostname)) {
      console.error('Internal IP not allowed:', hostname);
      return false;
    }

    return true;
  } catch (error) {
    console.error('Invalid URL format:', error);
    return false;
  }
};

// Helper function to check if the IP is internal
const isInternalIp = (hostname) => {
  // Regex for IPv4 and IPv6 private addresses and localhost
  const privateIpRegex =
    /^(localhost|127\.0\.0\.1|::1|10\.\d{1,3}\.\d{1,3}\.\d{1,3}|172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3}|192\.168\.\d{1,3}\.\d{1,3}|fc00::|fe80::)/;

  return privateIpRegex.test(hostname);
};
